const KPIListjson = [
    {
        ID: 1, 
        name: "Creating innovative solutions to meet our company’s technical needs"
    },
    {
        ID: 2, 
        name: "Managing the software development lifecycle"
    },
    {
        ID: 3, 
        name: "Developing and executing project plans"
    },
    {
        ID: 4, 
        name: "Applying best practices and standard operating procedures"
    }
]

export default KPIListjson